var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWire = function SvgIconWire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M37.339 22.171h-2.13V4.853a3.13 3.13 0 0 0-3.126-3.126H6.913a3.13 3.13 0 0 0-3.126 3.126v17.322h-2.13a.656.656 0 0 0-.657.657v1.112a3.33 3.33 0 0 0 3.328 3.329h30.344A3.333 3.333 0 0 0 38 23.944v-1.112a.656.656 0 0 0-.657-.657zM2.72 22.171H35.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m25.197 10.886-6.51 6.51a.747.747 0 0 1-1.03 0l-3.862-3.862a.72.72 0 0 1-.214-.514c0-.196.075-.376.214-.515a.723.723 0 0 1 1.03 0l3.02 3.02c.18.18.474.18.654 0l5.669-5.668a.747.747 0 0 1 1.03 0c.138.139.213.319.213.514a.72.72 0 0 1-.214.515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.1 22.077v1.135c0 .635.515 1.15 1.15 1.15h10.492a1.15 1.15 0 0 0 1.15-1.15v-1.135"
  })));
};
export default SvgIconWire;